import { PartialRequestStatusRendererMap } from '@models/request-status';
import { I9DocumentReviewTranslation } from '@screens/review-section2/document-review/review-translations';
import { FocusedError } from '@screens/review-section2/styles';
import { IDocumentReviewStore } from '@stores/onboarding-review/document-review-store';
import { observer } from 'mobx-react';
import * as React from 'react';

export const DocumentLoadingStatus: React.FunctionComponent<{
    store: IDocumentReviewStore;
    translations: Record<I9DocumentReviewTranslation, string>
}> = observer(({ store, translations }) => {
    const statusRendererMap: PartialRequestStatusRendererMap = {
        error: () => <FocusedError>{translations.errorLoadingDocuments}</FocusedError>,
        pending: () => <p>{translations.loadingDocuments}</p>
    };
    const statusRenderer = statusRendererMap[store.loadingDocumentsRequestStatus];
    return statusRenderer?.() ?? null;
});



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-review/document-loading-status.tsx